module.exports = __webpack_public_path__ + "img/bg-alt.f32e6d42.svg";